var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAgentsInactive = function SvgAgentsInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B2C9DE",
    d: "M12 8V4v4ZM18 8H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2ZM2 14h2-2ZM20 14h2-2ZM15 13v2-2ZM9 13v2-2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6E5F2",
    fillRule: "evenodd",
    d: "M7 4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3h5a3 3 0 0 1 3 3v3h1a1 1 0 1 1 0 2h-1v3a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-3H2a1 1 0 1 1 0-2h1v-3a3 3 0 0 1 3-3h5V5H8a1 1 0 0 1-1-1ZM6 9a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1H6Zm3 3a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1Zm6 0a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 13a1 1 0 1 1 2 0v2a1 1 0 1 1-2 0v-2ZM14 13a1 1 0 1 1 2 0v2a1 1 0 1 1-2 0v-2Z"
  })));
};
export default SvgAgentsInactive;